// @shared

export interface Preset {
  key: string
  title: string
  emoji: string
}

export const CHARACTERS_FEMALE: Preset[] = [
  { key: "nova", title: "Нова", emoji: "🙂" },
  { key: "mia", title: "Мия", emoji: "💃" },
  { key: "lia", title: "Лия", emoji: "🎀" },
  { key: "eva", title: "Ева", emoji: "🤸‍♀️" },
]

export const CHARACTERS_MALE: Preset[] = [
  { key: "alex", title: "Алекс", emoji: "🧑‍🎓" },
  { key: "sam", title: "Сэм", emoji: "🧔" },
  { key: "kai", title: "Кай", emoji: "😎" },
  { key: "max", title: "Макс", emoji: "🎒" },
]

// Единый список — пригодится на рендере комнаты, когда пол не важен
export const ALL_CHARACTERS: Preset[] = [
  ...CHARACTERS_FEMALE,
  ...CHARACTERS_MALE,
]

export const HAIRSTYLES_FEMALE: Preset[] = [
  { key: "long", title: "Длинные", emoji: "💁‍♀️" },
  { key: "bun", title: "Пучок", emoji: "👩" },
  { key: "curly", title: "Кудри", emoji: "👩‍🦱" },
  { key: "short", title: "Короткие", emoji: "👩‍🦰" },
  { key: "shag", title: "Шэг", emoji: "✂️" },
  { key: "wolf", title: "Волчья", emoji: "🐺" },
]

export const HAIRSTYLES_MALE: Preset[] = [
  { key: "short", title: "Короткие", emoji: "👨" },
  { key: "curly", title: "Кудри", emoji: "👨‍🦱" },
  { key: "cap", title: "Кепка", emoji: "🧢" },
  { key: "buzz", title: "Ёжик", emoji: "👨‍🦲" },
  { key: "shag", title: "Шэг", emoji: "✂️" },
  { key: "wolf", title: "Волчья", emoji: "🐺" },
]

export const CLOTHES_FEMALE: Preset[] = [
  { key: "tshirt", title: "Футболка", emoji: "👕" },
  { key: "shirt", title: "Рубашка", emoji: "👔" },
  { key: "dress", title: "Платье", emoji: "👗" },
  { key: "hoodie", title: "Худи", emoji: "🧥" },
]

export const CLOTHES_MALE: Preset[] = [
  { key: "tshirt", title: "Футболка", emoji: "👕" },
  { key: "hoodie", title: "Худи", emoji: "🧥" },
  { key: "shirt", title: "Рубашка", emoji: "👔" },
]

export const SKIN_COLORS = ["#f1c8a3", "#e0ac80", "#b6815a", "#8a5a3a", "#5d3a24"]
export const HAIR_COLORS = ["#292B33", "#4a2c1a", "#c77e3e", "#e3c069", "#b7aa98", "#77736f", "#d1d1d1", "#d94a4a"]
export const CLOTHES_COLORS = [
  "#e86a3a",
  "#e1c159",
  "#55a85a",
  "#4a8fd1",
  "#8a4cc4",
  "#d74c7d",
  "#2c2c2c",
  "#f5f1e6",
]

export function charactersFor(gender: "male" | "female"): Preset[] {
  return gender === "female" ? CHARACTERS_FEMALE : CHARACTERS_MALE
}

export function hairstylesFor(gender: "male" | "female"): Preset[] {
  return gender === "female" ? HAIRSTYLES_FEMALE : HAIRSTYLES_MALE
}

export function clothesFor(gender: "male" | "female"): Preset[] {
  return gender === "female" ? CLOTHES_FEMALE : CLOTHES_MALE
}
